<template>
  <v-content>
    <v-row class="section">
      <last-feed v-if="latestFeed"/>
      <v-col v-else>
        <div class="display-1 no-feeds">No Feeds Today</div>
      </v-col>
    </v-row>
    <v-row class="section start">
      <start-feed/>
    </v-row>
    <account-info/>
    <add-feed/>
    <history/>
  </v-content>
</template>

<script>
import {mapGetters} from 'vuex';
import LastFeed from '../components/LastFeed';
import StartFeed from '../components/StartFeed';
import AddFeed from '../components/AddFeed';
import History from '../components/History';
import AccountInfo from '../components/AccountInfo';

export default {
  name: 'Home',
  components: {AccountInfo, History, AddFeed, StartFeed, LastFeed},
  computed: {
    ...mapGetters('auth', [
      'isAuthenticated'
    ]),
    ...mapGetters('feeds', [
      'latestFeed',
      'todaysFeeds'
    ])
  }
};
</script>

<style scoped>
  .no-feeds {
    margin-top: 20vh;
  }
</style>

